import React, { useState } from 'react';
import { Box, Button, Stack, TextField } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import Loader3D from '../../../../../components/Loader/Loader3D';
import { CancelButton, EditButton, SubmitButton } from '../../../../../components/mui/Buttons/Buttons';
import { editAttendancePerDay, getTrainerData } from '../../../../../redux/features/CRDslice';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';

const EditAttendancePerDay = ({ row, dispatchParams, activeType, crm }) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const { loading } = useSelector((store) => store.crd);
  const { enqueueSnackbar } = useSnackbar();
  const initialValues = {
    attendance_per_day: row?.attendance_per_day,
    trainer_assignment_id: row?.trainer_assignment_id,
  };

  const schema = Yup.object({
    attendance_per_day: Yup.number().required('Attendance per day is required'),
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues,
    validationSchema: schema,
    onSubmit: (values) => {
      console.log(values);
      dispatch(editAttendancePerDay(values)).then((res) => {
        if (res.payload.status === 'error') {
          enqueueSnackbar(res.payload.message, {
            variant: 'error',
          });
        } else if (res.payload.status === 'success') {
          handleCancel();
          dispatch(getTrainerData(dispatchParams));
          enqueueSnackbar(res.payload.message, {
            variant: 'success',
          });
        }
      });
    },
  });
  const handleCancel = () => {
    setOpen(false);
    formik.resetForm();
  };
  return (
    <GlobalDialog
      maxWidth={'sm'}
      fullWidth
      title={'Action'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      closeCondition={handleCancel}
      popupButton={
        <>
          <EditButton size="small" disabled={row?.mapping_status != 1} action={() => setOpen(true)}>
            Edit
          </EditButton>
        </>
      }
      content={
        open ? (
          loading ? (
            <Loader3D />
          ) : (
            <>
              <FormikProvider value={formik}>
                <Form onSubmit={formik.handleSubmit}>
                  <Box>
                    <Stack gap={2}>
                      <Box>
                        <TextField
                          type="text"
                          autoComplete="off"
                          fullWidth
                          id="attendance_per_day"
                          label="Attendance Per Day"
                          name="attendance_per_day"
                          value={formik.values.attendance_per_day}
                          onChange={formik.handleChange}
                          error={formik.touched.attendance_per_day && Boolean(formik.errors.attendance_per_day)}
                          helperText={formik.touched.attendance_per_day && formik.errors.attendance_per_day}
                       
                        />
                      </Box>
                    </Stack>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                    <Stack direction={'row'} spacing={1}>
                      <CancelButton action={() => handleCancel()}>Cancel</CancelButton>

                      <SubmitButton disabled={loading} type="submit">
                        {loading ? 'Submiting...' : 'Submit'}
                      </SubmitButton>
                    </Stack>
                  </Box>
                </Form>
              </FormikProvider>
            </>
          )
        ) : null
      }
    />
  );
};

export default EditAttendancePerDay;
